import { APP_ENV_SUBDOMAIN } from './APP_ENV_SUBDOMAIN';

export const getEventURL = (eventId: string) =>
  `https://${APP_ENV_SUBDOMAIN}.wagl.golf/event/${eventId}`;
